import urls from "../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../utils/service";

export async function getCountry() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETCOUNTRY, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getState(countryId: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETSTATEBYCOUNTRYID + countryId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getCity(stateId: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETCITYBYSTATEID + stateId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getTimeZone(countryId: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETTIMEZONEBYCOUNTRYID + countryId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
